var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 29,
    r: 29,
    fill: "#EBF5FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.9375 22.75C29.9375 22.2322 29.5178 21.8125 29 21.8125C28.4822 21.8125 28.0625 22.2322 28.0625 22.75V30.25C28.0625 30.5451 28.2014 30.8229 28.4375 31L33.4375 34.75C33.8517 35.0607 34.4393 34.9767 34.75 34.5625C35.0607 34.1483 34.9767 33.5607 34.5625 33.25L29.9375 29.7812V22.75Z",
    fill: "#0A57FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.5 29C41.5 35.9036 35.9036 41.5 29 41.5C22.0964 41.5 16.5 35.9036 16.5 29C16.5 22.0964 22.0964 16.5 29 16.5C35.9036 16.5 41.5 22.0964 41.5 29ZM39.625 29C39.625 34.868 34.868 39.625 29 39.625C23.132 39.625 18.375 34.868 18.375 29C18.375 23.132 23.132 18.375 29 18.375C34.868 18.375 39.625 23.132 39.625 29Z",
    fill: "#0A57FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVIcon);
export default __webpack_public_path__ + "static/media/v-icon.06a51d6367c8dc6e5e1bc10df25e6258.svg";
export { ForwardRef as ReactComponent };